/* Make the "Following on Shop" label legible on the dark footer.
 *
 * Shopify's <shop-follow-button> renders its label inside a SHADOW ROOT with
 * a hardcoded `text-black` class. It exposes no ::part() hooks and consumes
 * no CSS custom properties, so nothing in the theme's stylesheet can reach
 * it — on a #121212 footer the label is black on black.
 *
 * The shadow root is open, so a stylesheet can be adopted into it. We target
 * `.text-black` specifically rather than every span, so only the thing that
 * is actually unreadable changes and the purple badge, icons and any future
 * markup are left alone.
 *
 * The component is upgraded by an async module script, so the shadow root
 * does not exist at DOMContentLoaded. We watch for it and stop as soon as it
 * is painted.
 */
(function () {
  'use strict';

  var RULE = '.text-black { color: #fff !important; }';
  var SELECTOR = '.footer shop-follow-button';
  var deadline = 15000; // give up rather than observe forever
  var started = null;

  function paint(el) {
    var root = el.shadowRoot;
    if (!root || root.__mgPainted) return !!(root && root.__mgPainted);
    try {
      if ('adoptedStyleSheets' in root && typeof CSSStyleSheet === 'function') {
        var sheet = new CSSStyleSheet();
        sheet.replaceSync(RULE);
        root.adoptedStyleSheets = root.adoptedStyleSheets.concat(sheet);
      } else {
        var style = document.createElement('style');
        style.textContent = RULE;
        root.appendChild(style);
      }
      root.__mgPainted = true;
      return true;
    } catch (e) {
      return false;
    }
  }

  function sweep() {
    var nodes = document.querySelectorAll(SELECTOR);
    if (!nodes.length) return false;
    var all = true;
    Array.prototype.forEach.call(nodes, function (n) {
      if (!paint(n)) all = false;
    });
    return all;
  }

  function run() {
    started = started || Date.now();
    if (sweep()) return;
    if (Date.now() - started > deadline) return;
    requestAnimationFrame(function () {
      setTimeout(run, 150);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
